import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})

export class DispatchService35 {

  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }


  public sendMail(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.sendemails35+this.getCompanyID(),data);
  }

  public getflag_email(data){
    console.log("get email services");
    console.log(data);
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getStatus_correos+this.getCompanyID(),data);
  }

  public getPilotoData(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.envioCorreo.getPilotoData+this.getCompanyID(),data);
  }

  public sendPilotMails(data){
    console.log("Service");
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pilotmails+this.getCompanyID(),data);
  }


  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }


  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }


}
